<script>
	import { getContext, onMount, onDestroy } from 'svelte'
	import { styles } from '../scripts/styles'
	import { mapload } from './mapStore.js'
	import { maploaded } from './mapStore.js'

	let ready
	let zoom = 14

	let isLoaded
	const mapLoad = maploaded.subscribe((value) => {
		isLoaded = value
	})

	export let lat = null
	export let lng = null
	export let label = null

	lat = parseFloat(lat)
	lng = parseFloat(lng)

	const globals = getContext('globals')
	const fsS = globals.fsS

	const position = { lat: lat, lng: lng }
	//add the callback from google map link to window

	window.initMap = function ready() {
		mapload.set(true)
		maploaded.set(false)
	}

	onMount(async () => {
		mapload.subscribe((value) => {
			ready = value
			if (ready) {
				const mapContainer = document.querySelector('.map')
				const map = new google.maps.Map(mapContainer, {
					zoom,
					center: position,
				})

				const advancedMarker = new google.maps.Marker({
					position: new google.maps.LatLng({ lat, lng }),
					map,
					label,
				})
			}
		})
	})

	onDestroy(() => {
		mapLoad
	})
</script>

<div class="container">
	{#if !ready}
		<div class="waiting" use:styles={{ fsS }}>waiting for map</div>
	{/if}
	<div class="map" />
</div>

<svelte:head>
	{#if isLoaded}
		<script
			defer
			async
			src="https://maps.googleapis.com/maps/api/js?key=AIzaSyCeYI_EcAVic_PrIV2kazAOrLR61M-x9Ws&callback=initMap"
		></script>
	{/if}
</svelte:head>

<style>
	.container {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		width: clamp(200px, 22vw, 380px);
		height: clamp(200px, 22vw, 380px);
	}
	.map {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}

	.waiting {
		font-size: var(--fsS);
	}
</style>
